import { Component, EventEmitter, inject, Input, Output, signal, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageCroppedEvent, ImageCropperComponent, OutputFormat } from 'ngx-image-cropper';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-image-cropper-modal',
  imports: [CommonModule, ImageCropperComponent],
  templateUrl: './image-cropper-modal.html',
  styleUrl: './image-cropper-modal.css',
})
export class ImageCropperModal {
  private modalService = inject(ModalService);

  @ViewChild('cropperTemplate') cropperTemplate!: TemplateRef<any>;

  @Input() imageFile: File | null = null;
  @Input() aspectRatio: number = 16 / 9;
  @Input() resizeToWidth: number = 1200;
  @Input() resizeToHeight: number = 630;
  @Input() format: OutputFormat = 'webp';

  @Output() cropped = new EventEmitter<{ file: File; preview: string }>();
  @Output() cancelled = new EventEmitter<void>();

  croppedImage = signal<string | null>(null);
  croppedBlob: Blob | null = null;
  imageLoaded = signal(false);

  open() {
    this.croppedImage.set(null);
    this.croppedBlob = null;
    this.imageLoaded.set(false);
    this.modalService.open(this.cropperTemplate, '672px', () => {
      this.cancelled.emit();
    });
  }

  close() {
    this.imageFile = null;
    this.croppedImage.set(null);
    this.croppedBlob = null;
    this.modalService.close();
  }

  onImageCropped(event: ImageCroppedEvent) {
    if (event.blob) {
      this.croppedBlob = event.blob;
      const reader = new FileReader();
      reader.onload = () => {
        this.croppedImage.set(reader.result as string);
      };
      reader.readAsDataURL(event.blob);
    }
  }

  onImageLoaded() {
    this.imageLoaded.set(true);
  }

  onLoadImageFailed() {
    this.close();
  }

  applyCrop() {
    if (this.croppedBlob && this.imageFile) {
      const extension = this.format === 'webp' ? 'webp' : (this.format === 'png' ? 'png' : 'jpeg');
      const fileName = this.imageFile.name.replace(/\.[^/.]+$/, '') + '_cropped.' + extension;
      const file = new File([this.croppedBlob], fileName, { type: `image/${extension}` });
      this.cropped.emit({ file, preview: this.croppedImage()! });
      this.imageFile = null;
      this.modalService.close();
    }
  }
}
